// extracted by mini-css-extract-plugin
module.exports = {"btn":"DisableComputer_btn__39_hi"};